import { type ResolvedContextData } from '@common/defaults/ContextData';
import { ShowIcon } from '@common/svg/icons/components/ShowIcon';
import { WidgetType } from '@common/types/Sidebar';
import { getT, Ns } from '@web/i18n';
import { NewsBlockList } from '@web/molecules/NewsBlockItem/molecules/NewsBlockListItem/NewsBlockList';
import { NewsBlockListItem } from '@web/molecules/NewsBlockItem/molecules/NewsBlockListItem/NewsBlockListItem';
import { type NewsBlockListItemProps } from '@web/molecules/NewsBlockItem/molecules/NewsBlockListItem/types';
import { SimpleWidget } from '@web/organisms/SimpleWidget';
import { type SimpleWidgetConfig } from '@web/organisms/SimpleWidget/SimpleWidget.types';

import { getMostViewedThemeConfig } from './MostViewed.config';

interface Props {
    contextData: ResolvedContextData;
    dataList?: NewsBlockListItemProps[];
}

export const widgetConfig: SimpleWidgetConfig = {
    title: 'most-viewed.title',
    type: WidgetType.MOST_VIEWED,
};

export const Widget = ({ contextData, dataList }: Props) => {
    const __sidebar = getT(contextData.context.locale, Ns.Sidebar);
    const title = __sidebar(`${contextData.platform.id}.${widgetConfig.title}`);
    const metaSuffix = __sidebar('most-watched.count');
    const themeConfig = getMostViewedThemeConfig(contextData);
    return (
        <SimpleWidget
            contextData={contextData}
            title={title}
            titleIcon={themeConfig.brandedHeadingIcon}
            titleVariant={themeConfig.brandedHeadingVariant}
        >
            <NewsBlockList>
                {dataList?.map((data, i) => (
                    <NewsBlockListItem
                        key={i}
                        contextData={contextData}
                        metaSuffix={metaSuffix}
                        metaIcon={<ShowIcon />}
                        {...data}
                    />
                ))}
            </NewsBlockList>
        </SimpleWidget>
    );
};
